'use strict'

const methods = {
  PublicMethod(val) {
    return val
  },
  OpenWindow(path, hidemenu) {
    let url = location.href.split('#')[0] + '#' + path
    if (hidemenu) {
      if (url.indexOf('?') < 0) {
        url += '?'
      } else {
        url += '&'
      }
      url += 'nomenu=1'
    }
    window.open(url)
  },
  linebreak(val, reaplce = '<br />') {
    if (!val) return ''
    return val.replace(/\n/igm, reaplce)
  },
  triggerIntervalListener(flagKey) {
    localStorage.setItem(flagKey, 10);
  },
  setIntervalListener(flagKey, cb, stop = false, interval = 1500) {
    let timer = setInterval(() => {
      console.log('listen refresh =>' + flagKey)
      let data = localStorage.getItem(flagKey);
      if (data) {
        localStorage.removeItem(flagKey);
        // 是否触发后停止
        if (stop && timer) {
          clearInterval(timer)
        }
        cb && typeof (cb) === 'function' && cb()
      }
    }, interval);
    return timer;
  }
}

export default methods
